import { get } from "../common/dataFetch";
import { WebControllers } from "../constants/webControllers";
import { WebActionNames } from "../constants/webActionNames";
import { Answer } from "../store/answer";

export const updateRecord = (reportingId: string) => get<Answer>(WebControllers.Reporting, WebActionNames.UpdateRecord, { reportingId });
export const updateNavLink = (question: string, navLink: string) => get<Answer>(WebControllers.Reporting, WebActionNames.UpdateNavLink, { question, navLink });